import { render } from "./StreakComponent.vue?vue&type=template&id=ceda0f10"
import script from "./StreakComponent.vue?vue&type=script&lang=js"
export * from "./StreakComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__